import { render } from "./PortionForm.vue?vue&type=template&id=8884c2d0"
import script from "./PortionForm.vue?vue&type=script&lang=js"
export * from "./PortionForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__